import { useCallback } from 'react';

import request from 'lib/request';

interface ResponseType {
  code: number;
  msg: string;
  data?: null;
}
export function useUnbindSocialOAuth() {
  const twitterUnbind = useCallback(async () => {
    const res = await request<ResponseType>('/user_profile/remove_twitter', {
      method: 'POST',
    });
    if (res?.code === 0) {
      location.reload();
    }
  }, []);

  const discordUnbind = useCallback(async () => {
    const res = await request<ResponseType>('/user_profile/remove_discord', {
      method: 'POST',
    });
    if (res?.code === 0) {
      location.reload();
      localStorage.removeItem('Filter');
    }
  }, []);

  return { twitterUnbind, discordUnbind };
}
